import { FC } from "react";

import { AppFooter } from "@/blocks/AppFooter";
import { FullLogo } from "@/blocks/FullLogo";
import { HeaderMenuDropdown } from "@/blocks/HeaderMenuDropdown";
import { VnBox } from "@/components/VnBox";

type DashboardLayoutPropsType = {
  children: React.ReactNode;
  shouldShowFooter?: boolean;
};

const DashboardLayout: FC<DashboardLayoutPropsType> = ({
  children,
  shouldShowFooter = true,
}) => {
  return (
    <VnBox className="flex flex-1">
      <VnBox className="bg-sidebar flex flex-row items-center justify-between px-5 py-4 md:hidden">
        <FullLogo className="text-secondary" />
        <HeaderMenuDropdown />
      </VnBox>
      <VnBox className="flex flex-1">{children}</VnBox>
      {shouldShowFooter && <AppFooter />}
    </VnBox>
  );
};

export { DashboardLayout };
